let frontendAuth = true

import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import AppointmentCalendar from '../views/AppointmentCalendar.vue'
import Customers from "./customers";
import UserTypes from "./userTypes";
import Users from "./users";
import Events from "./events";
import Jobs from "./jobs";
import Items from "./items";
import Assets from "./assets";
import Tailors from "./tailors";
import Device from "./devices";
import Alterations from "./alterations";
import AlterationTypes from "./alterationtypes"
import ActivityTypes from "./activityTypes"
import AppointmentTypes from "./appointmentTypes"
import AppointmentOutcomes from "./appointmentOutcomes"
import Appointments from "./appointments"
import SuperAdmin from './superAdmin'
import Reporting from './reporting'
import Suppliers from './suppliers'
import SpecialOrders from './specialOrders'
import Locations from './locations'

Vue.use(VueRouter)

let routes = []
let defaultRoutes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },  
  {
    path: '/appointmentCalendar',
    name: 'AppointmentCalendar',
    component: AppointmentCalendar
  },  
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue'),
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('id')) next()
      else next({name: from.name})
    }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import(/* webpackChunkName: "Logout" */ '../views/Logout.vue'),
    // beforeEnter: (to, from, next) => {
    //   if (!localStorage.getItem('id')) next()
    //   else next({name: from.name})
    // }
  }
]

routes = routes.concat(
    defaultRoutes,
    Customers,
    UserTypes,
    Users,
    Events,
    Jobs,
    Items,
    Assets,
    Tailors,
    Device,
    Alterations,
    AlterationTypes,
    ActivityTypes,
    AppointmentTypes,
    AppointmentOutcomes,
    Appointments,
    SuperAdmin,
    Reporting,
    Suppliers,
    SpecialOrders,
    Locations
);

const router = new VueRouter({
  routes
})

if(frontendAuth){
  router.beforeEach((to, from, next) => {
    if (!localStorage.getItem('id') && to.path !== '/login') next({ name: 'Login' })
    else next()
  })
}


export default router
